function BenefitsSection() {
  const benefits = [
    {
      icon: "💰",
      title: "Recover Stuck Money",
      desc: "Get back money that's been stuck for years with proven strategies",
      highlight: "Years old payments"
    },
    {
      icon: "🎯",
      title: "30 Days Recovery",
      desc: "See your first recovery within 30 days of implementing the formula",
      highlight: "Guaranteed results"
    },
    {
      icon: "💎",
      title: "Work on Your Terms",
      desc: "Set your own prices and payment terms with confidence",
      highlight: "Your rules"
    },
    {
      icon: "⭐",
      title: "A-Class Fast Paying Customers Only",
      desc: "Attract quality customers and filter out bad payers automatically",
      highlight: "Premium clients"
    },
    {
      icon: "⚡",
      title: "40% to 50% Faster Collection",
      desc: "Cut your payment collection time in half without extra effort",
      highlight: "Save time"
    },
    {
      icon: "👥",
      title: "Trained Team for Payment Collection",
      desc: "Empower your team to handle collections without your intervention",
      highlight: "Delegate easily"
    }
  ];

  return (
    <section className="relative py-20 md:py-28 bg-black overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-green-500/5 to-emerald-500/5 rounded-full blur-[150px]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(16,185,129,0.05),transparent_50%)]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500/10 to-emerald-500/10 border border-green-500/20 text-green-400 px-5 py-2 rounded-full text-sm font-medium mb-6">
            <span className="text-lg">✨</span>
            Key Benefits
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4">
            What You'll
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400"> Achieve</span>
          </h2>
          
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Transform your payment collection process and watch your cash flow improve dramatically
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-900 to-gray-900/50 rounded-3xl p-8 border border-gray-800 hover:border-green-500/50 transition-all duration-500 hover:-translate-y-3 hover:shadow-2xl hover:shadow-green-500/10 overflow-hidden"
            >
              {/* Gradient Overlay on Hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-emerald-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Decorative Corner */}
              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-green-500/10 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              {/* Icon */}
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center text-4xl shadow-lg shadow-green-500/25 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                  {benefit.icon}
                </div>
                {/* Pulse Ring */}
                <div className="absolute inset-0 w-20 h-20 rounded-2xl border-2 border-green-500/50 opacity-0 group-hover:opacity-100 group-hover:scale-125 transition-all duration-700"></div>
              </div>

              {/* Content */}
              <div className="relative">
                <span className="inline-block text-green-400 text-xs font-bold uppercase tracking-wider mb-2">
                  {benefit.highlight}
                </span>
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-green-400 transition-colors duration-300">
                  {benefit.title}
                </h3>
                <p className="text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors duration-300">
                  {benefit.desc}
                </p>
              </div>

              {/* Bottom Indicator */}
              {/* <div className="mt-6 flex items-center gap-2 text-green-400">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-sm font-semibold">Guaranteed Result</span>
              </div> */}

              {/* Hover Arrow */}
              <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-4 group-hover:translate-x-0">
                <svg className="w-6 h-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BenefitsSection;
